// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2-WwS","title":"FrontImage_title__1gcOn"};